import { useEffect } from 'react';
import Tile from '../subcomponents/Tile';
import './styles/titleLogo.css';
import { ArrowRightLeft } from 'lucide-react';
import { applyTitleAnimation } from '../utils/animationHelper';

interface TitleLogoProps {
  secondary?: boolean;
}

function TitleLogo(props: TitleLogoProps) {
  const { secondary } = props;

  useEffect(() => {
    applyTitleAnimation();
  }, []);
  return (
    <>
      {!secondary && (
        <div className="flex gap-1">
          <span className="flex items-center">
            <Tile id="title-1" titleSize green value="L" />
            <span className="title-text ml-[2px]">ETTER</span>
          </span>
          <span className="flex items-center mt-4">
            <Tile id="title-2" titleSize bonus value="S" />
            <span className="title-text">WAP</span>
          </span>
        </div>
      )}
      {secondary && (
        <div className="title-container">
          <span className="title-wrapper-v2">
            LETTER <ArrowRightLeft className="title-icon" /> SWAP
          </span>
        </div>
      )}
    </>
  );
}

export default TitleLogo;
